/*************************************************************************
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import PropTypes from "prop-types";
import CustomIconV3 from "./CustomIconV3";
import CustomIconV2 from "./CustomIconV2";
import { LIB_VERSION } from "../../Constants/enums";

const CustomIcon = props => {
  const version = props.compVersion;
  if (version === LIB_VERSION.RSPV3) {
    return <CustomIconV3 {...props} />;
  }
  return <CustomIconV2 {...props} />;
};

CustomIcon.propTypes = {
  compVersion: PropTypes.oneOf(Object.values(LIB_VERSION))
};

CustomIcon.defaultProps = {
  compVersion: LIB_VERSION.RSPV2
};

export default CustomIcon;
